.location-search-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 12px 16px 24px;
  background: var(--color-bg-primary);
  font-family: "DM Sans", sans-serif;
}

.tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f1f2f4;
  margin: 0 -16px;
}

.tab {
  width: 200px;
  width: 100%;
  justify-content: center;
  height: 40px;
  background: #f7f7f8;
  color: var(--color-text-secondary);
  border-radius: 0;
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
}

.tab-active {
  background: var(--color-bg-primary-selected);
  color: var(--color-text-primary);;
}
.tab-inactive {
  background: var(--color-bg-primary);
  color: var(--color-text-secondary);
}
.tab-icon.tab-icon {
  font-size: 16px;
}
.tab-label {
  font-size: 14px;
  font-weight: 400;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.search-row {
  margin-bottom: 8px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);;
  border-radius: var(--radius-md);
  padding: 8px;
}

.search-icon.search-icon {
  color: var(--icon-icon-secondary, #61646B);
  margin-right: 8px;
  font-size: 18px;
}

.search-input {
  border: none !important; // Fix this
  padding: 0 !important; // Fix this
  outline: none;
  width: 100%;
  font-size: 1rem;
  padding: 0.5rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--text-text-secondary, #61646B);
}

.scrollable-results {
  scrollbar-width: thin;
}

.list-card {
  display: flex;
  flex-direction: column;
}

.location-row,
.station-row,
.row {
  text-align: left;
  width: 100%;
  border: none;
  background: transparent;
  padding: 12px 0;
  cursor: pointer;
  border-bottom: 1px solid #e5edea;
  font-family: "DM Sans", sans-serif;
}

.location-row + .location-row,
.station-row + .station-row,
.row + .row {
  border-top: none;
}

.location-row:hover,
.station-row:hover,
.row:hover {
  background: rgba(0, 0, 0, 0.02);
}

.location-primary,
.station-primary {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.location-secondary,
.station-secondary {
  font-weight: 200;
  color: var(--color-text-secondary);
  font-size: 13px;
  margin-top: 4px;
}

.location-section {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.section-title {
  font-weight: 400;
  color: #829e95;
  letter-spacing: 0.01em;
  font-size: 16px;
}

.muted {
  color: var(--color-gray-700);
  font-size: 0.9em;
  padding: 0.5rem 0.25rem;
  padding-left: 0;
}

.error {
  color: var(--color-error-600, #c00);
  padding: 0.5rem 0.25rem;
}

.station-search {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-height: 0;
}

.station-search-controls {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.5rem;
  margin-bottom: 8px;
}

.toggle-view {
  min-width: 130px;
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 400;
}

.station-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 16px;
}

.station-table-wrapper {
  display: flex;
  flex-direction: column;
  border: 1px solid #e5edea;
  overflow: hidden;
  height: 100%;
  min-height: 320px;
  flex: 1 1 auto;
  width: 100%;
}

.station-table-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  width: 100%;
}

.ag-grid-container {
  width: 100%;
  height: 100%;
  min-height: 0;
}

.station-grid {
  font-family: "DM Sans", sans-serif;
  --ag-foreground-color: #1b1e25;
  --ag-border-color: #e5edea;
  --ag-header-foreground-color: #1b1e25;
  --ag-header-background-color: #e5edea;
  --ag-row-hover-color: #f7f7f8;
  --ag-odd-row-background-color: #fff;
  --ag-header-height: 38px;
  --ag-font-size: 12px;

  font-size: var(--font-size-12);
  height: 374px;

  :global(.ag-header-cell) {
    font-weight: 600;
    padding-left: 8px;
  }

  :global(.ag-row) {
    cursor: pointer;
  }

  :global(.ag-row .ag-cell) {
    cursor: pointer;
  }

  :global(.ag-cell) {
    font-size: 14px;
    align-items: center;
    display: flex;
  }
}

.station-grid-font {
  
  :global(.ag-root, .ag-header, .ag-body-viewport, .ag-cell, .ag-header-cell) {
    font-size: var(--font-size-12) !important;
  }
}

.table-scroll {
  max-height: 360px;
  overflow: auto;
}

.station-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-12);
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  background: rgba(0, 0, 0, 0.03);
}

.table-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px;
  border-top: 1px solid var(--color-gray-200, #e0e0e0);
  background: var(--color-bg-primary);
}

.footer-controls {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--color-text-secondary);
  font-size: var(--font-size-12);
}

.ghost-button {
  background: none;
  border: none;
  width: 28px;
  height: 28px;
  cursor: pointer;
  color: #888;
  font-size: 18px;
}

.ghost-button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-size-select {
  padding: 4px 6px 2px 6px;
  border: none;
  border-bottom: 1px solid #bdbdbd;
  background: transparent;
  color: #1b1e25;
  font-size: var(--font-size-12);
  width: 75px;
}

.page-size-select:focus {
  outline: none;
  border-bottom-color: #61646b;
}

.items-label {
  color: var(--color-text-secondary);
}

.range {
  color: var(--color-text-secondary);
  min-width: 120px;
  text-align: right;
  display: inline-block;
}

.explicit-coords-panel {
  display: flex;
  justify-content: space-between;

  .title {
    color: var(--color-text-secondary);
    font-weight: 200;
    margin-right: 0.5rem;
    text-transform: capitalize;
  }

  .value {
    font-weight: 500;
  }
}

.location-secondary {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.station-secondary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.divider {
  height: 0;
  border: 1px solid var(--divider-divider-primary, #F1F2F4);
  margin: 0px -16px;
  margin-bottom: 8px; 
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #1b1e25;
  }
}

.header-spacer {
  width: 12px;
  opacity: 0;
}

.close-button {
  width: 16px;
  height: 16px;
  padding: 2px;
  background: #d9d9d9;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.highlight {
  background: #ffedb5;
  color: inherit;
  padding: 0 1px;
  border-radius: 2px;
}

.station-alt {
  margin-left: auto;
  color: var(--color-text-secondary);
}

.location-type {
  margin-left: auto;
  text-align: right;
}
